import {actions as A} from '../constants/actions';

const defaultState = {
  stepStatus: null,
  loading: false,
  error: false,
  errorMessage: null
};

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case A.GET_SHUMA_STEPS_STATUS:
      const {resetValues} = payload;
      return {...state, loading: true, error: false, stepStatus: !resetValues && state.stepStatus};

    case A.GET_SHUMA_STEPS_STATUS_SUCCESS:
      return {...state, loading: false, error: false, stepStatus: payload};

    case A.GET_SHUMA_STEPS_STATUS_FAILURE:
      return {...state, loading: false, error: true, errorMessage: payload};

    case A.CLEAR_INSPECTION:
      return {...defaultState};

    default:
      return state;
  }
}

